import api from "./axios";

export const createCoupon = async (payload) => {
  const response = await api.post("/coupon", payload);
  return response.data;
};

export const getCoupons = async () => {
  const response = await api.get("/coupon");
  return response.data;
};


export const updateCoupon = async (id, payload) => {
  const response = await api.put(`/coupon/${id}`, payload);
  return response.data;
};

export const deleteCoupon= (id) => {
  return api.delete(`/coupon/delete/${id}`);
};

export const getCouponById = (id) => {
  return api.get(`/coupon/company/${id}`);
};

